import { IStateCallback, State } from '@autopylot-internal/state';
import { Device } from '../../support/Device.ts';
import { IPaymentTerm } from './RevenueCatModel.ts';
import { IFreeTierLimits } from './IOfferMeta.ts';
import { RevenueCatWebAdapter } from './RevenueCatWebAdapter.ts';
import { RevenueCatNativeAdapter } from './RevenueCatNativeAdapter.ts';

export interface IRevenueCatAdapter {
    subscribe: (callback: IStateCallback<any>) => () => void;
    init: () => Promise<void>;
    canMakeRealPayment: () => boolean;
    upgrade: (term: IPaymentTerm) => Promise<void>;
    restore: () => Promise<void>;
    getFreeTierLimits: () => IFreeTierLimits | undefined;
    isEligibleForTrial: () => boolean;
    getManagementLink: () => string | undefined;
    getDiagnostics: () => { [label: string]: any };
};

export class RevenueCatSDKModel extends State<Record<string, never>> {

    private adapter: IRevenueCatAdapter;

    static inject = () => [
        RevenueCatNativeAdapter,
        RevenueCatWebAdapter,
        Device
    ];
    constructor(
        nativeAdapter: RevenueCatNativeAdapter,
        webAdapter: RevenueCatWebAdapter,
        deviceInfo: Device
    ) {
        super({});

        const isNative = (['ios', 'android'].includes(deviceInfo.platform));

        if (isNative) {
            this.adapter = nativeAdapter;
        } else {
            this.adapter = webAdapter;
        }

        this.adapter.subscribe(() => this.setState({}));
    }

    init = async () => await this.adapter.init();

    canMakeRealPayment = () => this.adapter.canMakeRealPayment();

    upgrade = async (term: IPaymentTerm) => await this.adapter.upgrade(term);

    restore = async () => await this.adapter.restore();

    getFreeTierLimits = () => this.adapter.getFreeTierLimits();

    isEligibleForTrial = () => this.adapter.isEligibleForTrial();

    getManagementLink = () => this.adapter.getManagementLink();

    getDiagnostics = () => this.adapter.getDiagnostics();
}
